<template>
  <div id="scientist" class="application-section scientist">
    <section id="employmentSection">
      <div class="container is-fluid">
        <ChooseQuestion question="I am currently" :options="employmentStatuses"
                        @question-answered="empStatusSelected" closingSentence="."
                        :class="[{error: $v.understandingYou.employmentStatus.$error}, 'employment-size']" :isMandatory="true"
                        :isDropdownControlled="true" :existingValue="understandingYou.employmentStatus"
                        :tab="sections.employmentSection.tab" />
        <b-field :message="{'Please confirm your employment status.': $v.understandingYou.employmentStatus.$error}"></b-field>
        <ChooseQuestion question="My primary sector of pharmacy is"
                        :options="sectors" @question-answered="sectorSelected"
                        closingSentence="." :existingValue="understandingYou.sector"
                        :tab="sections.employmentSection.tab" />
        <FreetextQuestion :question="workStatement" @question-answered="jobTitleEntered"
                          :existingValue="understandingYou.jobTitle" :tab="sections.employmentSection.tab"  closingTag="." maxlength="100"/>
        <FreetextQuestion question="at" @question-answered="organizationEntered" :tab="sections.employmentSection.tab"
                closingTag="." :isNotDisplayed="true" :existingValue="understandingYou.organization" maxlength="100"/>
      </div>
    </section>
    <section id="uploadSection" :class="sections.uploadSection">
      <div class="container is-fluid">
        <FreetextQuestion question="The area of pharmaceutical science that I currently work in is"
                          closingTag="." :class="{error: $v.understandingYou.area.$error }"
                          @question-answered="areaEntered" :isDisabled="sections.uploadSection.ghost" :isMandatory="true"
                          :isDropdownControlled="true" :isNotDisplayed="true" :existingValue="understandingYou.area"
                          :tab="sections.uploadSection.tab" maxlength="100" />
        <b-field :message="{'This field cannot be left blank.': $v.understandingYou.area.$error}"></b-field>
        <FileUpload question="Please attach a copy of your degree certificate (or equivalent) or higher qualification."
                    :isDisabled="sections.uploadSection.ghost" @file-uploaded="degreeAttached" @file-deleted="degreeDeleted"
                    :class="{error: $v.understandingYou.degreeFile.$error }" :tooltip="!$store.state.isMobile ? tooltipCert: ''" :isMandatory="true"
                    :existingValue="understandingYou.degreesDoc" uploadedText="This is the degree uploaded" :isMobile="$store.state.isMobile"
                    :tab="sections.uploadSection.tab" />
        <b-field :message="{'Please upload a copy of your degree certificate.': $v.understandingYou.degreeFile.$error}"></b-field>
      </div>
    </section>
    <section id="uploadSection2" :class="sections.uploadSection">
      <div class="container is-fluid">
        <FileUpload question="If you feel it would support your application you can also attach a copy of your CV."
                    :isDisabled="sections.uploadSection.ghost" @file-uploaded="cvAttached" @file-deleted="cvDeleted"
                    :tooltip="!$store.state.isMobile ? tooltipCv : ''" :tab="sections.uploadSection2.tab"
                    :existingValue="understandingYou.cvDoc" uploadedText="This is the cv uploaded" :isMobile="$store.state.isMobile"/>
        <div v-if="!this.$store.state.isMobile" id="confirm-wrap">
          <button class="btn-confirm" @click.stop.prevent="$emit('confirmClicked')" type="button">Next</button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FreetextQuestion from '@/components/FreetextQuestion.vue';
import ChooseQuestion from '@/components/ChooseQuestion.vue';
import FileUpload from '@/components/FileUpload.vue';
import '@/styles/application.scss';
import { required, requiredIf } from 'vuelidate/lib/validators';
import ghost from '@/understandingyou/scripts/ghost';

export default {
  name: 'PharmaceuticalScientist',
  components: {
    FreetextQuestion,
    ChooseQuestion,
    FileUpload,
  },
  props: {
    dataGetter: Function,
  },
  updated() {
    this.$emit('onFinalSection', this.isFinalSectionVisible);
  },
  data() {
    return {
      placeholder: 'Please tell us more',
      tooltipCert: 'Attach your certificate(s) as one document.',
      tooltipCv: 'Attach your CV as one document.',
      sections: {
        employmentSection: { hidden: false, ghost: false, tab: 0 },
        uploadSection: { hidden: false, ghost: true, tab: this.$store.state.isMobile ? -1 : 0 },
        uploadSection2: { hidden: false, ghost: true, tab: this.$store.state.isMobile ? -1 : 0 },
      },
      understandingYou: this.dataGetter(),
    };
  },
  computed: {
    ...mapGetters(['employmentStatuses', 'sectors']),
    isFinalSectionVisible() {
      return this.sections.uploadSection.hidden === false;
    },
    workStatement() {
      return ghost.workStatement(this.understandingYou.employmentStatus);
    },
    degreeNotSelected() {
      return this.understandingYou.degreesDoc === '';
    },
  },
  methods: {
    empStatusSelected(e) {
      this.understandingYou.employmentStatus = e.text;
      ghost.showSection(this.sections.uploadSection);
      ghost.showSection(this.sections.uploadSection2);
    },
    sectorSelected(s) {
      this.understandingYou.sector = s.text;
    },
    jobTitleEntered(j) {
      this.understandingYou.jobTitle = j;
    },
    areaEntered(a) {
      this.understandingYou.area = a;
    },
    degreeAttached(d) {
      this.understandingYou.degreeFile = d;
    },
    degreeDeleted() {
      this.understandingYou.degreeFile = '';
    },
    organizationEntered(o) {
      this.understandingYou.organization = o;
    },
    cvAttached(c) {
      this.understandingYou.cvFile = c;
    },
    cvDeleted() {
      this.understandingYou.cvFile = '';
    },
    HasErrorInSection(comp) {
      const { understandingYou: scientist } = this.$v;
      const sectionValidations = {
        employmentSection() {
          scientist.employmentStatus.$touch();

          return scientist.employmentStatus.$error;
        },
        uploadSection() {
          scientist.area.$touch();
          scientist.degreeFile.$touch();

          return scientist.area.$error || scientist.degreeFile.$error;
        },
      };
      const validation = sectionValidations[comp];

      if (validation) {
        return validation();
      }

      return false;
    },
    SetIndexes(current, next) {
      this.sections[current].tab = -1;
      this.sections[next].tab = 0;
    },
  },
  validations() {
    return {
      understandingYou: {
        employmentStatus: {
          required,
        },
        area: {
          required,
        },
        degreeFile: {
          required: requiredIf(() => this.degreeNotSelected),
        },
      },
    };
  },
};
</script>
<style>
  #employmentSection div.field p.help {
    font-family: "Poppins", Arial, sans-serif;
    font-weight: 100;
    font-size: 12px;
    color: red;
  }

  #uploadSection div.field p.help {
    font-family: "Poppins", Arial, sans-serif;
    font-weight: 100;
    font-size: 12px;
    color: red;
    margin-bottom: 30px
  }

  #uploadSection div.error div.dropdowncontrol {
    margin-bottom: 5px;
  }
  #employmentSection div.error {
    margin-bottom: 5px;
  }
</style>
